<template>
    <div class="container">
        <h1>Quality Assurance</h1>
        <el-alert
            :closable="false"
            title="Not finding the facility you are looking for?"
            description="The table below only lists national facilities that have been evaluated and accepted in ACTRIS and have been enrolled in the QA process. If the facility you are looking for does not appear in the table it might mean evaluation process has not been finalized, in which case you will find it in the Initial Acceptance page."
            type="primary"
            show-icon
        >
        </el-alert>
        <div class="row justify-content-center">
            <div class="col">
                <FacilitiesTable show-qa evaluated-only />
            </div>
        </div>
    </div>
</template>

<script>
import FacilitiesTable from '@/components/facilities/FacilitiesTable.vue'

export default {
    name: 'CARSFacilitiesQAList',
    components: {
        FacilitiesTable
    },
    data: () => {
        return {
        }
    },
    head: {
        title: 'Evaluate National Facilities'
    },
    methods: {
    },
    async mounted() {
    }
}
</script>